import React, { useEffect, useState } from "react";

import { LogoOriginal } from "../_components/Imagepath";
import PropTypes from "prop-types";
const LoadingPage = ({ loading }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!loading) {

      setFadeOut(true); // Start fade-out animation
      setTimeout(() => setVisible(false), 1000); // Remove from DOM after animation
    }
  }, [loading]);
  const loadingStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    opacity: fadeOut ? 0 : 1,
    transition: "opacity 1s ease",
  };
  if (!visible) return null; // Remove from DOM after fade-out
 

  return (
    <div style={loadingStyle}>
      <img src={LogoOriginal} alt="Logo" style={{ 
      position: "absolute", 
      top: "50%", 
      left: "50%", 
      transform: "translate(-50%, -50%)" 
    }} />

    </div>
  );
};

LoadingPage.propTypes = {
  loading: PropTypes.bool.isRequired, // Ensure `loading` is a boolean
};

export default LoadingPage;
